<!-- <li class="panel"> -->
<div class="controparte">
	<p class="col-sm-2">
		<button (click)="emitEntity(beneMobile)" class="btn btn-primary associa"
			type="submit">Allega</button>
	</p>
	<div>
		<h4 class="titolo col-sm-3">{{beneMobile.tipoBeneMobile.label}}
		</h4>
		<p class="col-sm-2">
			Rif: <strong>{{beneMobile.riferimentoInventario?
				beneMobile.riferimentoInventario: ''}}</strong>
		</p>
		<p class="col-sm-3">
			Valore bene: <strong>{{beneMobile.valore? (beneMobile.valore
				| euro) + ' &euro;': ''}}</strong>
		</p>
		<p class="col-sm-2 status">
			<strong>{{beneMobile.istanzaAssegnazione &&
				beneMobile.istanzaAssegnazione.assegnato ? 'ASSEGNATO': 'NON
				ASSEGNATO'}}</strong>
		</p>
	</div>
</div>
<!-- </li> -->
